import React from 'react'
import { ScrollView, StyleSheet, View } from 'react-native'

import ConfettiCelebration from '../../components/Mini/ConfettiCelebration'

import * as pocketPick from '@/router/(root)/pocketPick/pocketPickModule'
import { PocketPickBackground as Background } from "@/components/Mini/Background"
import { PocketPickHeader as Header } from "@/components/Mini/Header"
import { PocketPickStatsCard as StatsCard} from "@/components/Mini/StatsCard"
import { PocketPickStreakStats as StreakStats} from "@/components/Mini/StreakStats"
import { PocketPickLeaderboardCard as LeaderboardCard} from "@/components/Mini/LeaderboardCard"
import { PrimaryBtn } from "@/components/Mini/Button"
import { PocketPickDiamondsCard as DiamondsCard } from "@/components/Mini/DiamondsCard"

import type { MinigameModule } from '@/types/minigameModule'

function PocketPickResultsScreen(){

  const m = pocketPick

  const isPerfect = m.useIsPerfect()
  const playedDate = m.useStore((s) => s.playedDate)

  const { isAdmin, isSuperAdmin } = m.usePocketPickUser()

  return (
    <>
      {isPerfect && <ConfettiCelebration />}
      <Background>
        <ResultsScreenHeader m={m}/>
        <ScrollView contentContainerStyle={styles.scrollContent} showsVerticalScrollIndicator={false}>
          <StatsCard />
          {(isAdmin || isSuperAdmin) && <DiamondsCard />}
          <StreakStats />
          <LeaderboardCard compact={true} />
        </ScrollView>
        <Footer />
      </Background>
    </>
  )

}

function ResultsScreenHeader ({ m }: { m: MinigameModule }) {

  const handleHome = m.useHandleHome()

  return (
    <Header title="Your Results" handler={handleHome} />
  )
}

function Footer(){

  return (
    <View style={styles.footer}>
      <ShareBtn />
    </View>
  )
  
}

function ShareBtn(){

  const handleShare = pocketPick.useHandleShare()

  const theme = pocketPick.useStore(s => s.theme)

  return (
    <PrimaryBtn theme={theme} handler={handleShare} label="Share your results" />
  )
}

const styles = StyleSheet.create({
  fill: { flex: 1 },
  scrollContent: { paddingHorizontal: 16, paddingBottom: 16,  gap: 16 },
  footer: { paddingHorizontal: 24, paddingBottom: 16, paddingTop: 8, gap: 12 }
})

export { PocketPickResultsScreen }
